/**
 * The Workspace workload a storage path belongs to, over the same namespaces the gateway's own
 * path classifier recognizes. Needed because the generic file explorer names no item kind, so a
 * path taken from it must be routed to the typed restore endpoint matching its workload.
 */
type GoogleWorkspaceWorkload = 'mail' | 'drive' | 'sharedDrive' | 'group';

/** The search index namespaces trashed Drive entries under `trash/`, ahead of their workload. */
export const TRASH_PATH_PREFIX_PATTERN = /^trash\//;

export const googleWorkspaceWorkloadFromPath = (
  storagePath: string
): GoogleWorkspaceWorkload | undefined => {
  const segments = storagePath
    .replace(TRASH_PATH_PREFIX_PATTERN, '')
    .split('/')
    .filter((segment) => segment.length > 0);

  if (segments[0] === 'shared_drives') {
    return segments.length > 1 ? 'sharedDrive' : undefined;
  }
  if (segments[0] === 'groups') {
    return segments.length > 1 ? 'group' : undefined;
  }
  if (segments[0] === 'users' && segments.length > 2) {
    switch (segments[2]) {
      case 'gmail':
        return 'mail';
      case 'drive':
        return 'drive';
    }
  }
  return undefined;
};
